import { c as _c } from "react/compiler-runtime";
import { Radio } from '@common/components';
import { QuantityStepper } from '@/components/molecule/QuantityStepper';
const OPTION_SEPARATOR = ': ';

//* 운영자가 고정한 옵션을 보여주기만 한다 — 신청 API에 옵션·수량 필드가 없어 서버로 보내지 않는다
export const CampaignOptionPreview = t0 => {
  const $ = _c(17);
  const {
    optionNames
  } = t0;
  if (optionNames.length === 0) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== optionNames) {
    const optionList = optionNames.map(_temp);
    t4 = "hidden flex-col gap-16 mobile-tablet:flex";
    t5 = optionList.map(_temp2);
    t3 = "flex items-center justify-between gap-8 rounded-small bg-Gray-25 p-12";
    t1 = "text-Gray-800 typo-caption1";
    t2 = optionList.map(_temp3).join(" ");
    $[0] = optionNames;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t2) {
    t6 = <span className={t1}>{t2}</span>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <QuantityStepper count={1} max={1} disabled={true} className="mobile-tablet:h-36 mobile-tablet:w-90" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t6) {
    t8 = <div className={t3}>{t6}{t7}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
function _temp(optionName) {
  const separatorIndex = optionName.indexOf(OPTION_SEPARATOR);
  return separatorIndex < 0 ? {
    groupName: "",
    itemName: optionName
  } : {
    groupName: optionName.slice(0, separatorIndex),
    itemName: optionName.slice(separatorIndex + OPTION_SEPARATOR.length)
  };
}
function _temp2(t0) {
  const {
    groupName,
    itemName
  } = t0;
  return <div key={`${groupName}-${itemName}`} className="flex flex-col">{groupName ? <p className="font-700 text-Gray-black typo-body4">{groupName}</p> : null}<Radio.Group value={itemName} readOnly={true} theme="black"><div className="flex items-center border-b border-Gray-200 py-16"><Radio.Item value={itemName} className="flex-1 gap-16"><span className="text-left text-Gray-700 typo-body4">{itemName}</span></Radio.Item></div></Radio.Group></div>;
}
function _temp3(t0) {
  const {
    itemName: itemName_0
  } = t0;
  return itemName_0;
}